import React from 'react';

const FibonacciProofLesson = ({ onBack }) => {
  const openPlayground = () => {
    window.open('https://playground.miden.xyz', '_blank');
  };

  return (
    <section className="playground-page">
      <div className="game-header">
        <button onClick={onBack} className="back-button">
          ← Back to Playground
        </button>
      </div>

      <div className="lesson-page">
        <h2>Invisible Math · Challenge</h2>
        <p className="lesson-intro">
          You see the final result of a calculation, but not the steps. Learn how zero‑knowledge style
          proofs can convince others the math is correct without showing every line.
        </p>

        <div className="lesson-content">
          <h3>Story: Hidden Sequence</h3>
          <ul className="lesson-list">
            <li>
              Imagine you compute a long sequence (like Fibonacci) on your own device and only show the
              final number to a verifier.
            </li>
            <li>
              The verifier does not want to redo the whole sequence, but still needs to know you did it
              correctly.
            </li>
            <li>
              A proof system lets you attach a compact proof: "this result came from running the right
              program on some hidden inputs."
            </li>
            <li>
              The verifier checks only the proof. If it passes, they learn the result is valid without
              seeing each intermediate step.
            </li>
            <li>
              This is the core idea behind "invisible math": correctness is public, raw data can stay
              private.
            </li>
          </ul>
        </div>

        <div className="lesson-actions">
          <button className="activity-button" onClick={openPlayground}>
            Open official Miden Playground
          </button>
          <p className="lesson-footnote">
            For developers: in the Playground, pick a math‑style example (e.g. sequences or arithmetic),
            and try to map each stack change to the hidden‑sequence story here.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FibonacciProofLesson;

